import { type FunctionComponent, useCallback } from 'react';

import { useCoreDispatch } from '../store/CoreStore';
import { headerActions } from '../store/slices/header/slice';

import { MessageReceiver } from './MessageReceiver';
import { type IncomingMessage, MessageGroup } from './types';

export const LobbyMessageReceiver: FunctionComponent = () => {
  const dispatch = useCoreDispatch();

  const handleLobbyMessage = useCallback(
    (message: IncomingMessage): void => {
      if (message?.group === MessageGroup.Lobby) {
        switch (message?.name) {
          case 'toggleBackToGame': {
            const payload = message?.payload as { isHidden: boolean };
            dispatch(headerActions.setBackToGameHidden(payload.isHidden));
            break;
          }
          default: {
            break;
          }
        }
      }
    },
    [dispatch]
  );

  return <MessageReceiver handler={handleLobbyMessage} />;
};
